import { render } from "./MypageMonthlyFoodsRankingPage.vue?vue&type=template&id=1b5d3ffc&scoped=true&ts=true"
import script from "./MypageMonthlyFoodsRankingPage.vue?vue&type=script&lang=ts"
export * from "./MypageMonthlyFoodsRankingPage.vue?vue&type=script&lang=ts"

import "./MypageMonthlyFoodsRankingPage.vue?vue&type=style&index=0&id=1b5d3ffc&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d3ffc"]])

export default __exports__